import {EventEmitter, Injectable, Output} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BlocklyHeaderButtonsService {

  @Output() refreshListener: EventEmitter<any> = new EventEmitter();
  @Output() autoSuggestKeyListener: EventEmitter<any> = new EventEmitter();
  predicativeAutoSuggest: boolean;
  autosuggestLocalKey = 'blbas';

  refreshLoading = false;

  constructor() { }

  initAutoSuggest() {
    let valueset = false;
    if (localStorage.getItem(this.autosuggestLocalKey)) {
      if (localStorage.getItem(this.autosuggestLocalKey) === 'enabled') {
        this.predicativeAutoSuggest = true;
        valueset = true;
      } else if (localStorage.getItem(this.autosuggestLocalKey) === 'disabled') {
        this.predicativeAutoSuggest = false;
        valueset = true;
      }
    }
    if (!valueset) {
      this.predicativeAutoSuggest = false;
      localStorage.setItem(this.autosuggestLocalKey, 'disabled');
    }
  }

  updateAutoSuggest(value) {
    if (value) {
      this.predicativeAutoSuggest = true;
      localStorage.setItem(this.autosuggestLocalKey, 'enabled');
    } else {
      this.predicativeAutoSuggest = false;
      localStorage.setItem(this.autosuggestLocalKey, 'disabled');
    }
    this.autoSuggestKeyListener.emit(true);
  }

}
